import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import AccessibleIcon from '../AccessibleIcon'
import styles, { iconTheme, iconSize, buttonSize, buttonTheme } from './styles'

const BadgeButton = ({ theme, size, onClick, icon, className, disabled, ariaLabel, innerRef }) => (
  <button
    className={cx(styles.button, className, buttonSize(size), buttonTheme(theme))}
    type="button"
    onClick={onClick}
    ref={innerRef}
    disabled={disabled}
    aria-label={ariaLabel}>
    <AccessibleIcon icon={icon} size={iconSize(size)} color={iconTheme(theme)} />
  </button>
)

BadgeButton.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]),
  size: PropTypes.oneOf(['', 'default', 'extraSmall', 'small', 'medium']),
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'light', 'dark', 'tertiary', 'info', 'legacy']),
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.elementType]),
    }),
  ]),
}

BadgeButton.defaultProps = {
  size: 'default',
  theme: 'primary',
}

export default BadgeButton
